var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChild = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40px",
  height: "40px",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "child",
  fillRule: "nonzero",
  fill: "#4A4A4A"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-16",
  transform: "translate(13.000000, 13.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.81,11.968 C7.02922692,12.8039599 4.96877308,12.8039599 3.188,11.968 C2.16281549,12.8083337 1.56890919,14.0644198 1.57,15.39 L10.428,15.39 C10.4290908,14.0644198 9.83518451,12.8083337 8.81,11.968 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,11.97 C9.30542423,11.97 11.985,9.29042423 11.985,5.985 C11.985,2.67957577 9.30542423,2.0239886e-16 6,0 C2.69457577,-2.0239886e-16 0.015,2.67957577 0.015,5.985 C0.015,9.29042423 2.69457577,11.97 6,11.97 Z M0.65,5.69 C3.27296894,6.19871645 5.98083867,5.41930215 7.932,3.594 C8.56968764,5.095107 9.76803791,6.28807545 11.272,6.919 C10.7574487,9.68843251 8.18636198,11.5865465 5.38820859,11.26273 C2.59005521,10.9389136 0.520436792,8.50375382 0.652,5.69 L0.65,5.69 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 3.576,
  cy: 6.706,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 8.422,
  cy: 6.706,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,10.286 C6.565,10.286 7.075,10.048 7.297,9.679 C7.35594882,9.58289556 7.35914867,9.46264257 7.30539419,9.36353917 C7.25163971,9.26443577 7.14909749,9.20153812 7.03639419,9.19853917 C6.92369089,9.19554021 6.81794882,9.25289556 6.759,9.349 C6.669,9.495 6.389,9.652 5.999,9.652 C5.599,9.652 5.321,9.495 5.239,9.348 C5.14925372,9.19888313 4.95561689,9.15075374 4.80650001,9.24050001 C4.65738313,9.33024628 4.60925374,9.52388312 4.699,9.673 C4.919,10.041 5.429,10.279 5.999,10.279 L6,10.286 Z",
  id: "Shape"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChild);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/child.c213be3d44d43112b04e745482b5401b.svg";